import React from 'react';
import {
  Divider,
  H1,
  H2, StackLayout,
} from "@salt-ds/core";
import "./CardHeader.css";


function CardHeader(props) {
  return (
    <StackLayout gap={1}>
      <H1>
        {props.heading}
      </H1>
      <Divider className="form-card-line" style={props.style} aria-hidden="true"/>
      <H2>
        {props.subheading}
      </H2>
    </StackLayout>
  );
}

export default CardHeader;